(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-reels"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.instagram-reels').forEach((section) => {
    if (section.dataset.playerReady === 'true') return;
    section.dataset.playerReady = 'true';

    const dialog = section.querySelector('.instagram-reels__dialog');
    const player = section.querySelector('.instagram-reels__player');
    const closeButton = section.querySelector('.instagram-reels__close');

    const closePlayer = () => {
      const activeVideo = player.querySelector('video');
      if (activeVideo) activeVideo.pause();
      if (dialog.open) dialog.close();
      player.replaceChildren();
    };

    section.querySelectorAll('[data-video-src]').forEach((button) => {
      button.addEventListener('click', () => {
        const video = document.createElement('video');
        video.src = button.dataset.videoSrc;
        video.poster = button.dataset.videoPoster;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.setAttribute('aria-label', button.getAttribute('aria-label'));
        player.replaceChildren(video);
        dialog.showModal();
        video.play().catch(() => {});
      });
    });

    closeButton.addEventListener('click', closePlayer);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closePlayer();
    });
    dialog.addEventListener('close', () => player.replaceChildren());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
